module.exports = __webpack_public_path__ + "static/media/equals.b95dda9c.bin";